import { Select } from "components/ui/select";
import { AdvancedSearchEntityType, BridgeEntityResult } from "generated/graphql";
import React, { useCallback } from "react";
import { entityTypeOptions } from "./entity-type-selection";

interface EntityTypeEditorProps {
    entityType: AdvancedSearchEntityType;
    onChange: (entityType: AdvancedSearchEntityType) => void;
    entities: BridgeEntityResult[];
    allowedEntityTypes?: AdvancedSearchEntityType[];
    textSize?: "sm";
    preLabel?: string;
    postLabel?: string;
}

export const EntityTypeEditor: React.FC<EntityTypeEditorProps> = props => {
    const {
        entityType,
        onChange,
        entities,
        allowedEntityTypes,
        textSize,
        preLabel,
        postLabel,
    } = props;

    const onDropdownChange = useCallback(
        (e: React.ChangeEvent<HTMLSelectElement>) => {
            onChange(e.target.value as AdvancedSearchEntityType);
        },
        [onChange],
    );

    const options = entityTypeOptions(
        allowedEntityTypes ||
            (Object.keys(AdvancedSearchEntityType) as AdvancedSearchEntityType[]),
        entities,
    );

    const textSizeClass = textSize === "sm" ? "text-sm" : "";

    return options.length > 1 ? (
        <div className={`flex items-center space-x-2`}>
            {preLabel ? <p className={textSizeClass}>{preLabel}</p> : null}
            <Select
                value={entityType}
                onChange={onDropdownChange}
                textSize={textSize}
                disabled={options.length <= 1}>
                {options.map(option => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </Select>
            {postLabel ? <p className={textSizeClass}>{postLabel}</p> : null}
        </div>
    ) : (
        <p>{[preLabel, options[0]?.label || "", postLabel].join(" ")}</p>
    );
};
